module.exports = __webpack_public_path__ + "static/media/Data.7022385e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Data.png
// module id = 1045
// module chunks = 0